<script lang="ts">
	import qs from 'qs';
	import StrapiImage from './StrapiImage.svelte';
	import { trackLink } from './utils/mixpanel';

	interface Props {
		location?: 'article' | 'stock-tool' | 'ssb-projection' | 'tbill-calculator';
	}

	let { location }: Props = $props();

	async function getStickyAd(): Promise<StickyAd> {
		return fetch(
			`/api/sticky-ad?${qs.stringify({ nonce: Math.random(), ...(location ? { location } : {}) })}`
		).then((res) => {
			if (res.ok) {
				return res.json() as unknown as StickyAd;
			} else {
				throw new Error('Failed to fetch sticky ad');
			}
		});
	}
</script>

{#await getStickyAd() then data}
	{#if data.iframeMediaDesktop}
		<div class="element-visibility" data-type="sticky-ad" data-content={data.provider}>
			<p class="small-regular text-gray-mid mx-auto mb-1 w-full text-center">
				<span class="small-bold">Ad</span> • {data.provider}
			</p>
			<iframe
				title="Siderail Banner"
				src={data.iframeMediaDesktop.src}
				height={`${data.iframeMediaDesktop.height}`}
				width={`${data.iframeMediaDesktop.width}`}
			></iframe>
		</div>
	{:else}
		<div>
			<p class="small-regular text-gray-mid mx-auto mb-1 w-full text-center">
				<span class="small-bold">Ad</span> • {data.provider}
			</p>
			<a
				onclick={trackLink}
				href={data.url}
				target="_blank"
				rel="noreferrer"
				class="element-visibility mb-3 flex w-full justify-center"
				aria-label="sticky ad"
				data-type="sticky-ad"
				data-content={data.provider}
			>
				<StrapiImage cover={data.coverDesktop} alt="sticky ad" class="aspect-[6/5] w-full" />
			</a>
		</div>
	{/if}
{:catch}
	<div></div>
{/await}
